<template>
  <div class="brief-marcas-abm">
    <!-- <b-table hover
        responsive="sm" 
        class="registro"
        :items="marcas" 
        :fields="fields">
      <div slot="table-busy" class="text-center">
        <b-spinner class="table-spinner" label="Spinning" />
      </div>
      <template v-slot:cell(seleccionado)="data">
        <b-form-checkbox
            v-model="data.item.seleccionado"
            :value="Boolean(true)"
            :unchecked-value="Boolean(false)">
        </b-form-checkbox> 
      </template>
    </b-table> -->

    <div class="subtitulo">
      <label>Marcas Incluidas</label>
      <i class="fa fa-plus"
        id="add-marca"
        @click.prevent="agregarMarca">
      </i>
      <!-- <b-btn
          id="add-marca"
          variant="primary" 
          size="sm"
          @click.prevent="agregarMarca">
        <i class="fa fa-plus"></i>
      </b-btn> -->
    </div>

    <b-list-group :key="key" flush>
      <b-list-group-item v-for="marca in marcas" :key="marca.marcaId">
        <b-form-group> 
          <b-form-checkbox 
              :id="marca.marca"
              :class="{ 'inactivo': marca.inactivo }"
              v-model="marca.seleccionado">
              {{ marca.marca }}
          </b-form-checkbox>
          <b-input-group-append 
              class="filter-search-icons">
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item
                  @click="editarMarca(marca)">
                <i class="fa fa-edit"></i>Editar Marca</b-dropdown-item>
            </b-dropdown>
          </b-input-group-append>
        </b-form-group>
      </b-list-group-item>
    </b-list-group>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'brief/getField',
  mutationType: 'brief/updateField',
});

export default {
  name: 'BriefMarcasABM',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      fields: [
        { key: 'marca' },
        {
          key: 'seleccionado',
          label: '',
          class: 'text-center'
        },
      ],

      labelCols: 2,
      key: 0,
    }
  },
  computed: {
    ...mapFields([
      'marcas',
    ]),
  },  
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    refresh() {
      this.key++;
    },
    agregarMarca() {
      this.$emit('agregarMarca');
    },
    editarMarca(marca) {
      this.$emit('editarMarca', marca);
    }    
  },
  watch: {
  }    
}
</script>

<style>
  .brief-marcas-abm {
    min-height: 300px;
  }
  .brief-marcas-abm .subtitulo,
  .brief-marcas-abm .subtitulo label,
  .brief-marcas-abm .subtitulo button {
    display: inline-block !important;
  }

  .brief-marcas-abm #add-marca {
    position: relative;
    margin-left: 10px;
    cursor: pointer;
    color: #20a8d8;
  }
  .brief-marcas-abm #add-marca:hover {
    color: #1b8eb7;
  }

  .brief-marcas-abm .form-group > div,
  .brief-marcas-abm .custom-checkbox,
  .brief-marcas-abm .filter-search-icons {
    display: inline-block;
  }
  .brief-marcas-abm .custom-checkbox.inactivo label {
    color: #73818f !important;
  }
  .brief-marcas-abm .filter-search-icons {
    position: relative;
    top: -2px;
    margin-left: 5px;
  }
  .brief-marcas-abm .filter-search-icons li {
    list-style: none !important;
  }
</style>